import React from "react";
import "./style.css";
import Particles from "../Particles/Particles";

const CallToActionPage = () => {
  return (
    <>
      <Particles title="Connect With Us" subTitle="" />
      <div className="call-to-action-page-wrapper">
        <div className="call-to-action-page-container">
          <h4>Collaborate with Soori Corporation</h4>
          <div className="row">
            <div className="col-12 col-md-6">
              <input
                type="text"
                name="fullName"
                placeholder="Full name"
                className="text-field"
              />
            </div>
            <div className="col-12 col-md-6">
              <input
                type="text"
                name="emailAddress"
                placeholder="Email address"
                className="text-field"
              />
            </div>
            <div className="col-12 col-md-6">
              <input
                type="text"
                name="companyName"
                placeholder="Company name"
                className="text-field"
              />
            </div>
            <div className="col-12 col-md-6">
              <input
                type="number"
                name="phoneNumber"
                placeholder="Phone number"
                className="text-field"
              />
            </div>
            <div className="col-12">
              <input
                type="text"
                name="aboutProject"
                placeholder="About your project"
                className="text-field"
              />
            </div>
            <div className="col-12">
              <label htmlFor="file" className="file-label">
                <i className="fa-solid fa-paperclip"></i>&nbsp; Attach a file
              </label>
              <input
                type="file"
                accept=".pdf, .docx, .odt, .ods, .ppt/x, .xls/x, .rtf, .txt"
                className="d-none"
                id="file"
              />
              <p className="my-2">
                Please upload a file with one of the following extensions: .pdf,
                .docx, .odt, .ods, .ppt/x, .xls/x, .rtf, .txt
              </p>
            </div>

            <div className="col-12">
              <input
                type="checkbox"
                name="privacy-notice"
                id="privacy-notice"
              />
              &nbsp;&nbsp;
              <label htmlFor="privacy-notice" className="checkbox-label">
                I have read&nbsp;
                <a href="#" className="text-secondary">
                  Privacy Notice
                </a>
              </label>
              <br />
              <input type="checkbox" name="agree" id="agree" />
              &nbsp;&nbsp;
              <label htmlFor="agree" className="checkbox-label">
                I agree to receive marketing materials about news, events, and
                proposals from Yalantis.
              </label>
            </div>
            <div className="col-12">
              <button type="button" className="btn btn-lg w-100 my-2">
                SEND MESSAGE
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallToActionPage;
